
export const ExperienceData = [
    {
        startDate: new Date(2021, 11),
        endDate: new Date(2024, 4),
        company: "VR Supersonic",
        career: "Junior/Junior+ Frontend Unity разработчик",
        description: "Стэк:\n" +
            "— Unity, C#;\n" +
            "— DI Framework (Zenject, VContainer);\n" +
            "— Unity Addressables (Local);\n" +
            "— Wave XR SDK, Pico XR SDK, Oculus XR SDK, Open XR SDK.\n" +
            "\n" +
            "Работа в команде:\n" +
            "— Подготовка и выпуск релизов;\n" +
            "— Проведение Code Review;\n" +
            "— Формирование Code Style.\n" +
            "\n" +
            "Разработка:\n" +
            "— Проектирование игровых систем;\n" +
            "— Реализация фич;\n" +
            "— Формулирование задач, определение сроков;\n" +
            "— Работа с Git по Git Flow.\n" +
            "\n" +
            "Достижения:\n" +
            "— Выведение понятного пайплайна разработки фич;\n" +
            "— Формулирование Git Flow для Unity команды;\n" +
            "— Рефакторинг систем, выполняющих обязанности Entry Point'ов и внедрение понятного пайплайна работы приложения;\n" +
            "— Оформление и поддержка Code Style;\n" +
            "— Формулирование и внедрение простой и понятной структуры проекта;\n" +
            "— Расширение \"парка\" поддерживаемых устройств;\n" +
            "— Ускорение выпуска Unity приложения (упрощен пайплайн)."
    },
    {
        startDate: new Date(2024, 4),
        endDate: new Date(2025, 3),
        company: "VR Supersonic",
        career: "Team Lead/Middle+ Frontend Unity разработчик",
        description: "Стэк:\n" +
            "— Unity, C#;\n" +
            "— DI Framework (Zenject, VContainer);\n" +
            "— Unity Addressables (Remote\\Local);\n" +
            "— Wave XR SDK, Pico XR SDK, Oculus XR SDK, Open XR SDK;\n" +
            "— i2 Localization;\n" +
            "— DOTween;\n" +
            "— UniTask.\n" +
            "\n" +
            "Работа в команде:\n" +
            "— Оптимизация процессов команды (полный цикл найма, адаптации сотрудников, принятие решений об увольнении/переводе на другую должность);\n" +
            "— Ведение разработки;\n" +
            "— Планирование спринта;\n" +
            "— Ведение \"дейли\" и ретроспективы;\n" +
            "— Участие в составлении плана развития продукта;\n" +
            "— Отслеживание выполнения задач;\n" +
            "— Помощь коллегам в выполнении задач;\n" +
            "— Подготовка и выпуск релизов;\n" +
            "— Проведение Code Review;\n" +
            "— Формирование Code Style.\n" +
            "\n" +
            "Разработка:\n" +
            "— Проектирование игровых систем;\n" +
            "— Анализ продукта;\n" +
            "— Решение бизнес задач;\n" +
            "— Проектирование архитектуры;\n" +
            "— Реализация фич;\n" +
            "— Формулирование задач, определение сроков;\n" +
            "— Работа с Git по Git Flow.\n" +
            "\n" +
            "Достижения:\n" +
            "— Внедрение Remote Addressables;\n" +
            "— Рефакторинг Core: TTS, STT, своеобразный Event Bus и др.;\n" +
            "— Написание новых State Machine;\n" +
            "— Рефакторинг как минимум 60% всего UI приложения;\n" +
            "— Внедрение MVX паттернов для UI;\n" +
            "— Оформление правил ведения технической документации;\n" +
            "— Внедрение Unit и Playmode (интеграционного) тестирования;\n" +
            "— Внедрение гибкой системы локализации (i2 Localization);\n" +
            "— Оптимизация процессов команд (Web, Unity, Analytics);\n" +
            "— Оптимизация процесса найма сотрудников в команду Unity;\n" +
            "— Почти полное обновление состава Unity команды."
    },
    {
        startDate: new Date(2025, 3),
        company: "Lesta Games",
        career: "Middle Fullstack Unity разработчик",
        description: "Стэк:\n" +
            "— Unity, C#;\n" +
            "— ASP.NET (сессионный сервер);\n" +
            "— RPC (self-created, based on LiteNetLib);\n" +
            "— DI Framework (self-created);\n" +
            "— Localization (self-created);\n" +
            "— Animation Tween (self-created);\n" +
            "— Message Pack;\n" +
            "— Docker;\n" +
            "— Kubernetes.\n" +
            "\n" +
            "Разработка:\n" +
            "— Проектирование игровых систем на основе собсвенных подходов;\n" +
            "— Решение бизнес задач;\n" +
            "— Проектирование архитектуры;\n" +
            "— Реализация фич;\n" +
            "— Формулирование задач, определение сроков;\n" +
            "— Работа с Git по Git Flow;\n" +
            "— Обсуждение\\выявление\\решение проблем архитектурных подходов;\n" +
            "— Работа с кластером серверов\\сервисов;\n" +
            "— Предложение\\обсуждение UI\\UX проблем;\n" +
            "— Координированная работа с множеством подразделений (Art, VFX, SFX, Legacy\\Localization).\n" +
            "\n" +
            "Достижения:\n" +
            "— Изучение всего стека и внутренних подходов в рекордно малые сроки (отмечено Team\\Tech-Lead как самое быстрое внедрение в проект, 1.5 месяца);\n" +
            "— Значимая помощь в переносе сервера с Unity на ASP.NET;\n" +
            "— Выявление нескольких критичных UX проблем, предложение решений по ним и полное их устранение;\n" +
            "— Разработана унифицированная система анимации, ставшая частью общей платформы;\n" +
            "— Разработана система клиентских и серверных читов для дебага игры;\n" +
            "— Полностью перепроектирована архитектуры клиента (в рамках выведения идей улучшения серверной архитектуры) для унификации подходов к разработке серверной и клиентской части приложения;\n" +
            "— Разработан интрумент для оптимизации рендеринга (overdraw monitor, помогает отслеживать лишние перерисовки объектов);\n" +
            "— Разработаны Unit-тесты для валидации текстур и компонентов;\n" +
            "— Переработано несколько ключевых мета систем (система локаций, работа с рекламой, логин через External сервисы (напр. Facebook), система баннеров (умных лутбоксов))."
    }
];
